import { IChatV3Schema } from '@cian/chats-api/lib/browser-entry';

import { IChat } from '../../types/chatList';
import { ITypedReduxAction } from '../../types/redux/actionType';
import { ERequestTrigger } from '../../types/requestTrigger';

export enum EChatListActionTypes {
  SetInitial = 'chats/chatsList/setInitial',
  // FIXME: Исправить редюсер
  SetPending = 'chats/chatsList/setPendingLegacy',
  TogglePending = 'chats/chatsList/togglePending',
  SetLoadPageSucceed = 'chats/chatsList/setLoadPageSucceed',
  SetSyncPending = 'chats/chatsList/setSyncPending',
  SetSyncSucceed = 'chats/chatsList/setSyncSucceed',
  SetSyncFailed = 'chats/chatsList/setSyncFailed',
  SetSucceed = 'chats/chatsList/setSucceed',
  SetFullSucceed = 'chats/chatList/setFullSucceed',
  SetFailed = 'chats/chatsList/setFailed',
  UpdatedFromServer = 'chats/chatsList/updatedFromServer',
  ToggleChangeListActive = 'chats/chatsList/toggleChangeListActive',
  AddChatToSelected = 'chats/chatsList/addChatToSelected',
  RemoveChatFromSelected = 'chats/chatsList/removeChatFromSelected',
  SelectAllChats = 'chats/chatsList/selectAllChats',
  DeselectAllChats = 'chats/chatsList/deselectAllChats',
}

export interface IChatListRequest {
  notClearCurrentOpenedChatId?: boolean;
  /** timestamp последнего чата, последней страницы */
  timestamp?: number;
  /** Флаг, который определяет, нужно ли объединять результат с текущим списком чатов */
  mergeResult?: boolean;
  /** Источник запроса, пишется в логи */
  trigger?: ERequestTrigger;
}

export type TChatListSetSucceedPayload = IChat[];

export type TChatListActions =
  | ITypedReduxAction<EChatListActionTypes.SetInitial, void>
  | ITypedReduxAction<EChatListActionTypes.SetLoadPageSucceed, void>
  | ITypedReduxAction<EChatListActionTypes.SetPending, IChatListRequest>
  | ITypedReduxAction<EChatListActionTypes.TogglePending, boolean>
  | ITypedReduxAction<EChatListActionTypes.SetSucceed, TChatListSetSucceedPayload>
  | ITypedReduxAction<EChatListActionTypes.SetFullSucceed, TChatListSetSucceedPayload>
  | ITypedReduxAction<EChatListActionTypes.SetFailed, void>
  | ITypedReduxAction<EChatListActionTypes.UpdatedFromServer, IChatV3Schema>
  | ITypedReduxAction<EChatListActionTypes.ToggleChangeListActive>
  | ITypedReduxAction<EChatListActionTypes.AddChatToSelected, string>
  | ITypedReduxAction<EChatListActionTypes.RemoveChatFromSelected, string>
  | ITypedReduxAction<EChatListActionTypes.SelectAllChats>
  | ITypedReduxAction<EChatListActionTypes.DeselectAllChats>
  | ITypedReduxAction<EChatListActionTypes.SetSyncPending, void>
  | ITypedReduxAction<EChatListActionTypes.SetSyncSucceed, TChatListSetSucceedPayload>
  | ITypedReduxAction<EChatListActionTypes.SetSyncFailed, void>;
